/**
 * Tenant context store (D-10).
 *
 * Tracks the current organization. Tenant switcher calls setTenant which
 * triggers queryClient.clear() + navigate to /dashboard in the sidebar.
 */
import { create } from 'zustand';

export interface TenantState {
  organizationId: string | null;
  organizationName: string | null;
  setTenant: (orgId: string, name: string) => void;
  clearTenant: () => void;
}

export const useTenantStore = create<TenantState>((set) => ({
  organizationId: null,
  organizationName: null,
  setTenant: (organizationId, organizationName) =>
    set({ organizationId, organizationName }),
  clearTenant: () =>
    set({ organizationId: null, organizationName: null }),
}));
